export const defaultLanguage = "en";
export const maintainedLanguages = {
  en: {
    name: "English",
    locale: "en",
  },
  fr: {
    name: "Français",
    locale: "fr",
  },
  es: {
    name: "Español",
    locale: "es",
  },
  pt: {
    name: "Português",
    locale: "pt",
  },
  ko: {
    name: "한국어",
    locale: "ko",
  },
  ja: {
    name: "日本語",
    locale: "ja",
  },
  it: {
    name: "Italiana",
    locale: "it",
  },
  de: {
    name: "Deutsch",
    locale: "de",
  },
  id: {
    name: "Bahasa Indonesia",
    locale: "id",
  },
  ru: {
    name: "Русский",
    locale: "ru",
  },
};
export const extractLangFromLocale = (locale) => locale.split("-")[0];

// Use Vite's import.meta.glob for better compatibility with Vite's build system
// This pre-registers all translation files at build time
const translations = import.meta.glob("../../compiled-lang/*.json");

export async function fetchMessages(lang) {
  const langCode = extractLangFromLocale(lang);
  const translationPath = `../../compiled-lang/${langCode}.json`;

  const loader = translations[translationPath];
  if (!loader) {
    throw new Error(`Translation file for language "${langCode}" not found at ${translationPath}`);
  }

  // Load the module and return the default export (or the module itself)
  const module = await loader();
  return module.default || module;
}

export function getDefaultLocale(maintainedLocales) {
  const clientLanguageLocale = extractLangFromLocale(getClientLocale());
  const languagePreferenceLocale = extractLangFromLocale(
    getClientLanguagePreferences().find(
      (preference) => maintainedLocales[extractLangFromLocale(preference)]
    ) || ""
  );
  return (
    maintainedLocales[clientLanguageLocale] ||
    maintainedLocales[languagePreferenceLocale] ||
    maintainedLocales[defaultLanguage]
  );
}

export function getClientLocale() {
  return window?.navigator?.language;
}

export function getClientLanguagePreferences() {
  return window?.navigator?.languages || [];
}

export const getLocalizationSettings = (settings, defaultSettings) => {
  const appFeatureFlagLocalization = settings?.appSettings?.feature_flags?.localization;
  const integratorFeatureFlagLocalization =
    settings?.integratorSettings?.feature_flags?.localization;
  return integratorFeatureFlagLocalization || appFeatureFlagLocalization || defaultSettings;
};
